import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import {BaseApiTemplateService, Core2Config} from "../../../shared";

import { ApiVisa, Pagination, PagingResponseModel } from '../../../shared';

@Injectable({ providedIn: 'root' })

export class ConversationReportService extends BaseApiTemplateService<any> {
  baseUrl: string;
  constructor(private http: HttpClient) {
    super();
    this.apiUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "reports"
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "reports"
    this.httpClient = http
  }


  public getConversationReport(apiVisa: ApiVisa, pagination: Pagination): Observable<PagingResponseModel<any>> {
    const UrlByCriteria = this.apiUrl + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(apiVisa)
    );
  }

  public getUserConversationReport(apiVisa:ApiVisa, pagination:Pagination): Observable<PagingResponseModel<any>> {
    const UrlByCriteria = this.apiUrl + '/users?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(apiVisa)
    );
  }
}